/**
 * Configuration and credential storage.
 *
 * Follows XDG Base Directory spec:
 *   $XDG_CONFIG_HOME/electric/ or ~/.config/electric/
 */

import { readFile, writeFile, mkdir, unlink } from 'node:fs/promises'
import { join } from 'node:path'
import { homedir } from 'node:os'

function getConfigDir(): string {
  return process.env.XDG_CONFIG_HOME
    ? join(process.env.XDG_CONFIG_HOME, `electric`)
    : join(homedir(), `.config`, `electric`)
}

function getAuthFile(): string {
  return join(getConfigDir(), `auth.json`)
}

export interface StoredAuth {
  token: string
  email: string
  expiresAt: string
}

export async function loadStoredAuth(): Promise<StoredAuth | null> {
  try {
    const raw = await readFile(getAuthFile(), `utf-8`)
    return JSON.parse(raw) as StoredAuth
  } catch {
    return null
  }
}

export async function saveStoredAuth(auth: StoredAuth): Promise<void> {
  const configDir = getConfigDir()
  await mkdir(configDir, { recursive: true })
  await writeFile(getAuthFile(), JSON.stringify(auth, null, 2), { mode: 0o600 })
}

export async function clearStoredAuth(): Promise<void> {
  try {
    await unlink(getAuthFile())
  } catch {
    // File doesn't exist — that's fine
  }
}

export { getConfigDir }
